import style from './social-link-component.module.scss';
import Image from 'next/image';
import deleteIcon from '/public/vacancies-images/icons/close.png';

interface IUploadedFileProps {
  link: string;
  deleteLink: () => void;
}

const SocialLinkComponent = ({ link, deleteLink }: IUploadedFileProps) => {
  return (
    <div className={`${style.container}`}>
      <div className={`${style.container__item__name}`}>{link}</div>
      <div className={`${style.container__item}`}>
        <div onClick={() => deleteLink()} className={`${style.container__item__delete}`}>
          <Image src={deleteIcon} alt={'delete-icon'} width="24px" height="24px" />
        </div>
      </div>
    </div>
  );
};

export default SocialLinkComponent;
